import React from 'react';
import './Breadcrumb.scss'

interface Link {
    name: string;
    active?: boolean;
}

interface BreadcrumbProps {
    links: Link[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links = [] }) => {
    return (
        <div className="tapps-breadcrumb">
            {links.map((link, index) => (
                <div key={index} className={`tapps-breadcrumb-link ${link.active ? 'active' : ''}`}>
                    {link.name}
                    {index < links.length - 1 && <span>/</span>}
                </div>
            ))}
        </div>
    );
};

export default Breadcrumb;
